(function (App, window, document, $) {

  let animationSpeed = 500;
  let topOfFormPosition = 332;

  App.scrollToFirstError = function(attempts = 0) {
    let $firstGroupWithError = $(".form-group.has-error").first()

    if ($firstGroupWithError.length > 0) {
      $("body, html").animate({ scrollTop: $firstGroupWithError.offset().top }, animationSpeed);
    }
    else {
      if (attempts < 6) { // check up to 6 times, waiting 50 milliseconds each time 😷
        setTimeout(function() { App.scrollToFirstError(attempts); }, 50);
      }
    }
  };

  App.scrollToFormTop = function() {
    $("body, html").animate({ scrollTop: topOfFormPosition }, animationSpeed);
  };

})(window.App = window.App || {}, window, document, window.jQuery);
